import {
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { getAdvancedMode, State } from 'search/reducers/root.reducer';
import {
  Facet,
  ResourceFacet,
} from 'search/facets/models/resource-facet';
import {
  ResourceFacetSelectedAction,
  HandleFacetsLockInStorage,
} from 'search/actions/facet.actions';
import { Subscription } from 'rxjs';
import { FacetLabelService } from 'search/services/facet-label.service';

@Component({
  selector: 'app-facet-filter',
  templateUrl: './facet-filter.component.html',
  styleUrls: ['./facet-filter.component.scss'],
})
export class FacetFilterComponent implements OnInit, OnDestroy {

  @Input() public facet: ResourceFacet;
  public facetLabel: string;

  private isAdvancedMode: boolean = false;
  private readonly subscriptions: Subscription = new Subscription();


  constructor(
    private readonly store: Store<State>,
    private readonly facetLabelService: FacetLabelService
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(this.store.select(getAdvancedMode).subscribe((advanced) => {
      this.isAdvancedMode = advanced;
    }));
    this.facetLabel = this.facetLabelService.getFacetLabel(this.facet);
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public onToggleBubbleLock(facet: Facet) {
    this.store.dispatch(new HandleFacetsLockInStorage({ facet }));
  }

  public onChange(checked: boolean, facet: Facet) {
    facet = {
      ...facet,
      selected: checked,
    };

    this.store.dispatch(new ResourceFacetSelectedAction(facet));
    if (checked && this.isAdvancedMode && !facet.isResetLocked) {
      this.store.dispatch(new HandleFacetsLockInStorage({facet}));
    }
  }
}
